export default {
  modelName: 'app',
  label: '客戶系統管理',
  fields: {
    id: {
      type: 'text',
      label: 'ID',
      readonly: true,
    },
    name: {
      type: 'text',
      label: '名稱',
    },
    access_token: {
      type: 'text',
      label: 'access token',
      readonly: true,
    },
    updated_at: {
      type: 'datetime',
      label: '最後更新時間',
      readonly: true,
    },
    updated_admin: {
      type: 'belongsTo',
      label: '最後更新人',
      readonly: true,
      textKey: 'name',
      modeldataName: 'admin',
    },
    created_at: {
      type: 'datetime',
      label: '建立時間',
      readonly: true,
      textKey: 'name',
    },
    created_admin: {
      type: 'belongsTo',
      label: '建立者',
      readonly: true,
      textKey: 'name',
    },
  },
};
